export default {
  columns: {
    strategy: 'Strategi',
    source: 'Kilde',
    async: 'Async',
    content: 'Indhold',
    edit: 'Rediger',
    delete: 'Slet',
  },
  buttons: {
    add_script: 'Tilføj script',
  },
};
